export const splitMultipleStringList = (
  stringList: string,
  delimiter = "__",
) => {
  return stringList.split(delimiter);
};
